import * as PIXI from "pixi.js";
import Game from "../../../../../src/Game";
import Layers from "../../../../../src/layers/Layers";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../managers/EventBus";
import CheckBox from "../../../../../src/entities/UI/Checkbox/Checkbox";
import { TangentType } from "../types/Enum";
import { TANGENT_TYPE_CON_COORD, TANGENT_TYPE_CON_OFFSET_VERTICAL } from "../types/Config";


export default class TangentTypeCon extends PIXI.Container {
	private Game = Game.getInstance();
	private Layers = Layers.getInstance();
	private type1!: CheckBox;
	private type2!: CheckBox;

	constructor() {
		super();
		this.addCoord();
		this.addCheckboxes();
		this.addToLayer();

		rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setVisible(false));
		rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setVisible(true));
	}

	addToLayer = () => this.Layers.UI.addChild(this);
	setVisible = (v: boolean) => this.visible = v;
	isPortial() {
		const dim = this.Game.getDim();
		return dim.HEIGHT > dim.WIDTH;
	}
	addCoord() {
		const dim = this.Game.getDim();
		let coord = TANGENT_TYPE_CON_COORD
		if (this.isPortial()) {
			coord = {
				x: dim.WIDTH / 2 + TANGENT_TYPE_CON_OFFSET_VERTICAL.x,
				y: dim.HEIGHT / 2 + TANGENT_TYPE_CON_OFFSET_VERTICAL.y
			}
		}
		Object.assign(this, coord);
	}

	addCheckboxes() {
		const isPortial = this.isPortial();
		this.type1 = new CheckBox({ x: 0, y: 0 }, "Tangent Type 1", 0xf94f6f, true, () => {
			this.type2.setChecked(false);
			eventBus.emit(EnumEventBus.setTangentType, TangentType.type1);
		});
		this.type1.setScale(isPortial ? 1 : .7);
		this.type1.setChecked(true);

		this.type2 = new CheckBox({ x: 0, y: isPortial ? 52 : 36 }, "Tangent Type 2", 0xf94f6f, true, () => {
			this.type1.setChecked(false);
			eventBus.emit(EnumEventBus.setTangentType, TangentType.type2);
		});
		this.type2.setScale(isPortial ? 1 : .7);
		
		[this.type1, this.type2].forEach(c => c.addToCon(this));
	}
}